import React, { ReactNode, ReactNodeArray } from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import SelfCareAbroadCustomerExistingPackagesBlockData from '../../../Models/Content/SelfCareAbroadCustomerExistingPackagesBlockData';
import SelfCareAbroadCustomerExistingPackagesMain from './SelfCareAbroadCustomerExistingPackagesMain'


export default class PopupBenefitBlock extends EpiComponent<SelfCareAbroadCustomerExistingPackagesBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <SelfCareAbroadCustomerExistingPackagesMain context={this.getContext()} iContent={this.props.data} />
  }
}
